import React from 'react'
import Navbar2 from '../Components/Navbar/Navbar2'
import DeleteForm from '../Components/DeleteForm/DeleteForm'
import Footer from '../Components/Footer/Footer'

function DeletePage() {
  return (
    <div>
        <Navbar2/>
        <DeleteForm/>
        <Footer/>
    </div>
  )
}

export default DeletePage